import Streaming from '../streaming/streaming';
import importantQuotes from '../modulos/importantQuotes/importantQuotes';
import {initTopBottom} from "../modulos/topbottom/topbottom";
import glossary from "../modulos/glossary/glossary";
import instrumentBox from "../modulos/instrumentBox/instrumentBox";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";

import {ultimosVideos} from "../modulos/ultimosVideos/ultimosVideos";
import {bolsaHoyImagesSlider} from "../modulos/bolsaHoy/bolsaHoyImages";

//Carga los módulos de la home
export const loadHome = () => {
    console.log('Loading home components');
    import("./css/index-home.scss");

    //Módulo que sustituye al antiguo carrusel superior de cotizaciones.
    importantQuotes(Streaming);

    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //InstrumentBox
    instrumentBox(Streaming);

    //Módulo de glosario
    glossary();

    //Módulo de análisis más vistos
    analisisMasVistos();

    //Últimos vídeos
    ultimosVideos();

    // Bolsa en directo en imágenes
    bolsaHoyImagesSlider();
}
